import AnchorLink from '../../src/legacy/AnchorLink';
export default AnchorLink;
